import { ACTION_TYPES } from './constants';

const initialState = {
    fingerprint: null,
    isInitialized: false
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.FINGERPRINT_INITIALIZED: {
            return {
                ...state,
                fingerprint: action.payload
            };
        }

        case ACTION_TYPES.INITIALIZE: {
            return {
                ...state,
                isInitialized: true
            };
        }

        default: return state;
    }
}
